import { Component } from '@angular/core';
import B2bB2cFormSwitcherService from './b2b-b2c-form-switcher.service';

@Component({
  selector: 'b2b-b2c-form-switcher',
  templateUrl: './b2b-b2c-form-switcher.component.html',
})
export default class B2bB2cFormSwitcherComponent {
  constructor(
    public switcher: B2bB2cFormSwitcherService
  ) {

  }
}
